import { useState, useEffect } from "react";
import { Form, Select, Space, Tooltip, Card, Typography, Row, Col } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";

const { Option } = Select;
const { Text } = Typography;

const InterestCalculator = ({
  onInterestTypeChange,
  interestType: parentInterestType,
  interestTypeOptions,
}) => {
  // State to track the selected interest type
  const [interestType, setInterestType] = useState(parentInterestType || "SI");

  // Update local state when parent prop changes
  useEffect(() => {
    if (parentInterestType && parentInterestType !== interestType) {
      setInterestType(parentInterestType);
    }
  }, [parentInterestType]);

  // Formula box rendering function
  const renderFormulaBox = (interestType) => {
    const formulaBoxStyle = {
      backgroundColor: "#f9f9f9",
      borderRadius: "8px",
      padding: "16px",
      marginBottom: "16px",
    };

    const bulletStyle = {
      display: "inline-block",
      width: "8px",
      height: "8px",
      borderRadius: "50%",
      backgroundColor: "#9c27b0", // Purple color
      marginRight: "12px",
    };

    if (interestType === "SI") {
      return (
        <Card style={formulaBoxStyle} bordered={false}>
          <Row justify="space-between" align="middle">
            <Col>
              <Space direction="horizontal" align="center">
                <Text strong style={{ fontSize: "20px" }}>
                  SI =
                </Text>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                  }}
                >
                  <Text strong style={{ fontSize: "20px" }}>
                    P × R × T
                  </Text>
                  <div
                    style={{
                      height: "1px",
                      width: "100%",
                      backgroundColor: "#d9d9d9",
                      margin: "4px 0",
                    }}
                  ></div>
                  <Text strong style={{ fontSize: "20px" }}>
                    100
                  </Text>
                </div>
              </Space>
            </Col>
            <Col>
              <Space direction="vertical" size="small">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={bulletStyle}></span>
                  <Text style={{ fontSize: "14px" }}>P = Principal amount</Text>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={bulletStyle}></span>
                  <Text style={{ fontSize: "14px" }}>
                    R = Annual Interest Rate (%)
                  </Text>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={bulletStyle}></span>
                  <Text style={{ fontSize: "14px" }}>T = Time (in years)</Text>
                </div>
              </Space>
            </Col>
          </Row>
        </Card>
      );
    } else if (interestType === "CI") {
      return (
        <Card style={formulaBoxStyle} bordered={false}>
          <Row justify="space-between" align="middle">
            <Col>
              <Space direction="horizontal" align="center">
                <Text strong style={{ fontSize: "20px" }}>
                  A =
                </Text>
                <Text strong style={{ fontSize: "20px" }}>
                  P(1 + r/n)<sup>nt</sup>
                </Text>
              </Space>
            </Col>
            <Col>
              <Space direction="vertical" size="small">
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={bulletStyle}></span>
                  <Text style={{ fontSize: "14px" }}>A = Final amount</Text>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={bulletStyle}></span>
                  <Text style={{ fontSize: "14px" }}>P = Principal amount</Text>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={bulletStyle}></span>
                  <Text style={{ fontSize: "14px" }}>
                    r = Annual interest rate (decimal)
                  </Text>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={bulletStyle}></span>
                  <Text style={{ fontSize: "14px" }}>
                    n = Number of times compounded per year
                  </Text>
                </div>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <span style={bulletStyle}></span>
                  <Text style={{ fontSize: "14px" }}>t = Time (in years)</Text>
                </div>
              </Space>
            </Col>
          </Row>
        </Card>
      );
    }

    return null;
  };

  // // Handle interest type change
  // const handleInterestTypeChange = (value) => {

  //   setInterestType(value);
  //   // Notify parent component about the change
  //   if (onInterestTypeChange) {
  //     onInterestTypeChange(value);
  //   }
  // };

  const handleInterestTypeChange = (value) => {
    // Convert numeric value to string format if needed
    const stringValue = value === 0 ? "SI" : value === 1 ? "CI" : value;

    setInterestType(stringValue);

    // Notify parent component about the change
    if (onInterestTypeChange) {
      onInterestTypeChange(stringValue);
    }
  };

  return (
    // <Form layout="vertical">
    <div>
      <Form.Item
        label={
          <Space>
            Interest Type
            <Tooltip title="Type of interest calculation">
              <InfoCircleOutlined />
            </Tooltip>
          </Space>
        }
        name="interestType"
      >
        <Select
          style={{ height: "44px" }}
          onChange={handleInterestTypeChange}
          // value={interestType}
          options={interestTypeOptions}
        />
      </Form.Item>

      {/* Render the formula box based on the selected interest type */}
      {renderFormulaBox(interestType)}
    </div>
    // </Form>
  );
};

export default InterestCalculator;
